import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/User.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private lastNetworkErrorShownAt = 0;

  constructor(private userService: UserService, private toastr: ToastrService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Get the token
    //const token = this.userService.getToken();   
    const tabId = sessionStorage.getItem('tabId');
    const tokenKey = `authToken-${tabId}`;
    const token = localStorage.getItem(tokenKey); 
    // Clone the request and add the Bearer token header if a token exists
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    // Clone the request and add additional headers
    const httpRequest = request.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
      }
    });

    return next.handle(httpRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        // Status 0 means the request never reached the server (network down, DNS, CORS); tell the user once
        if (error instanceof HttpErrorResponse && error.status === 0) {
          this.showNetworkError();
        }
        return throwError(() => error);
      })
    );
  }

  private showNetworkError(): void {
    const now = Date.now();
    if (now - this.lastNetworkErrorShownAt < 5000) {
      return;
    }
    this.lastNetworkErrorShownAt = now;
    const message = navigator.onLine === false
      ? $localize`Network is down. Please check your internet connection and try again.`
      : $localize`Unable to reach the server. Please check your connection and try again.`;
    this.toastr.error(message, $localize`Network Error`, { timeOut: 8000 });
  }
}
